import { ref } from 'vue'

export function useModalControl() {
  const isModalOpen = ref(false)

  // モーダルを開く関数
  function openModal(
    hasAnsweredFirstQuestion: boolean,
    currentQuestionIndex: number,
    nextQuestion: () => void,
  ) {
    isModalOpen.value = true
    document.body.style.overflow = 'hidden' // 背景のスクロールを無効化

    // モーダルを開いた時に、最初の質問に回答済みであれば次の質問に進む
    if (hasAnsweredFirstQuestion && currentQuestionIndex === 0) {
      nextQuestion()
    }
  }

  // モーダルを閉じる関数
  function closeModal(isFormSubmitted: boolean) {
    isModalOpen.value = false
    document.body.style.overflow = '' // 背景のスクロールを元に戻す
  }

  return {
    isModalOpen,
    openModal,
    closeModal,
  }
}
